/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1SsoimageIdMutationResponse,
  DeleteApiV1SsoimageIdPathParams,
  DeleteApiV1SsoimageId400,
  DeleteApiV1SsoimageId401,
  DeleteApiV1SsoimageId500,
} from "../../types/SSOImageController/DeleteApiV1SsoimageId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1SsoimageId } from "../../clients/SSOImageController/deleteApiV1SsoimageId.ts";

export const deleteApiV1SsoimageIdMutationKey = () =>
  [{ url: "/api/v1/ssoimage/:id" }] as const;

export type DeleteApiV1SsoimageIdMutationKey = ReturnType<
  typeof deleteApiV1SsoimageIdMutationKey
>;

export function deleteApiV1SsoimageIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = deleteApiV1SsoimageIdMutationKey();
  return mutationOptions<
    DeleteApiV1SsoimageIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SsoimageId400
      | DeleteApiV1SsoimageId401
      | DeleteApiV1SsoimageId500
    >,
    { id: DeleteApiV1SsoimageIdPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteApiV1SsoimageId(id, config);
    },
  });
}

/**
 * @description Desativa uma SSOImage e todos os seus idiomas. **(Requer Authorization para autenticação)**
 * @summary Excluir imagem SSO (soft delete) (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/:id}
 */
export function useDeleteApiV1SsoimageId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1SsoimageIdMutationResponse,
      ResponseErrorConfig<
        | DeleteApiV1SsoimageId400
        | DeleteApiV1SsoimageId401
        | DeleteApiV1SsoimageId500
      >,
      { id: DeleteApiV1SsoimageIdPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiV1SsoimageIdMutationKey();

  const baseOptions = deleteApiV1SsoimageIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1SsoimageIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SsoimageId400
      | DeleteApiV1SsoimageId401
      | DeleteApiV1SsoimageId500
    >,
    { id: DeleteApiV1SsoimageIdPathParams["id"] },
    TContext
  >;

  return useMutation<
    DeleteApiV1SsoimageIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SsoimageId400
      | DeleteApiV1SsoimageId401
      | DeleteApiV1SsoimageId500
    >,
    { id: DeleteApiV1SsoimageIdPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1SsoimageIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1SsoimageId400
      | DeleteApiV1SsoimageId401
      | DeleteApiV1SsoimageId500
    >,
    { id: DeleteApiV1SsoimageIdPathParams["id"] },
    TContext
  >;
}
